// extracted by mini-css-extract-plugin
module.exports = {"root":"ReceiptLine_root__LJZQ5","image":"ReceiptLine_image__7UgFI","text":"ReceiptLine_text__HjQ5e","close":"ReceiptLine_close__Q3ctj"};